import React from 'react'
import { ChevronRight, Globe } from 'lucide-react'
import { Link } from 'react-router-dom'
import { useTranslation } from '../hooks/use-i18n'

interface PlayWorldRoomBannerProps {
  showPlayWorldCta: boolean
  showViewWorldLink: boolean
  onOpenModal: () => void
  onLeaveWorld: () => void
  className?: string
  worldPath?: string
}

const PlayWorldRoomBanner: React.FC<PlayWorldRoomBannerProps> = ({
  showPlayWorldCta,
  showViewWorldLink,
  onOpenModal,
  onLeaveWorld,
  className = '',
  worldPath = '/public/football',
}) => {
  const { t } = useTranslation()

  if (!showPlayWorldCta && !showViewWorldLink) {
    return null
  }

  if (showPlayWorldCta) {
    return (
      <button
        type="button"
        onClick={onOpenModal}
        className={`w-full flex items-center gap-2.5 px-3 py-2 rounded-xl bg-primary/10 border border-primary/20 hover:bg-primary/15 transition-colors text-left ${className}`}
      >
        <Globe className="w-4 h-4 shrink-0 text-primary" />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-primary leading-tight">{t('room.playWorld')}</p>
          <p className="text-[11px] text-muted-foreground leading-snug mt-0.5">{t('room.playWorld.optionalHint')}</p>
        </div>
        <ChevronRight className="w-4 h-4 shrink-0 text-muted-foreground" />
      </button>
    )
  }

  return (
    <div className={`flex items-center justify-between gap-2 ${className}`}>
      <Link
        to={worldPath}
        className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors"
      >
        <Globe className="w-3.5 h-3.5" />
        {t('room.playWorld.viewRankings')}
      </Link>
      <button
        type="button"
        onClick={onLeaveWorld}
        className="text-xs text-destructive/90 hover:text-destructive shrink-0"
      >
        {t('worldFootball.leave.action')}
      </button>
    </div>
  )
}

export default PlayWorldRoomBanner
